import { call, put } from 'redux-saga/effects';
import { updateAnalyticTeam } from '../../../../state/analytic/analyticTeamSlice';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* updateTeamSaga(action) {
    const { teamId, teamName, teamDescription } = action.payload || {};
    try {
        const { data } = yield call(
            [backendClient, backendClient.patch],
            `teams/${encodeURIComponent(teamId)}`,
            { teamName, teamDescription }
        );
        yield put(updateAnalyticTeam({ teamId: data.teamId, teamName: data.teamName, teamDescription: data.teamDescription }));

        yield put(showSnackbar({
            message: `Team "${data.teamName}" updated successfully.`,
            severity: 'success',
        }));

    } catch (err) {
        const status = err?.response?.status;
        bugsnagClient.notify(err);
        console.error('Failed to update analytic team', status, err?.message);
        yield put(showSnackbar({
            message: `Failed to update team.`,
            severity: 'error',
        }));

    }
}